import clientConfig from '../../clientConfig';
import { ClientConfig } from '../../types';

export function getPingIdentityProfileUrl() {
  const pingIdentityAuth = (clientConfig as ClientConfig).pingIdentityAuth;

  if (!pingIdentityAuth?.enabled) {
    return '';
  }

  return pingIdentityAuth.profileHost;
}
